import axios from 'axios'
import router from '@/router'
import store from '@/store'

const JWTinterceptor = axios.create({
  baseURL: process.env.VUE_APP_SOFA_API,
});

JWTinterceptor.interceptors.request.use(
  (config) =>{
    const token = localStorage.getItem('token');
    if (token){
      config.headers['Authorization'] = `Bearer ${token}`;
      config.headers['x-access-tokens'] = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
)


JWTinterceptor.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (!error.response) {
      return Promise.reject(error)
    }


    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem('refreshToken');

      if (!refreshToken) {
        await store.dispatch('auth/logout')
        router.replace('/login')
        return Promise.reject(error)
      }
      try {
        const { data } = await axios.post(`${process.env.VUE_APP_SOFA_API}refresh`,
          { refresh_token: refreshToken });

        if (data?.responseCode === 200 && data?.responseData?.token) {
          const newToken = data.responseData.token;
          localStorage.setItem('token', newToken);
              originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
              originalRequest.headers['x-access-tokens'] = newToken;
            return JWTinterceptor(originalRequest);
        }

        await store.dispatch('auth/logout');
        router.replace('/login');
        return Promise.reject(error)

      } catch (refreshError) {
        await store.dispatch('auth/logout');
        router.replace('/login');
        return Promise.reject(refreshError)
      }
    }

    return Promise.reject(error)
  }
)

export default JWTinterceptor;
